import { render, staticRenderFns } from "./elConfigList.vue?vue&type=template&id=21904a5c&"
import script from "./elConfigList.vue?vue&type=script&lang=js&"
export * from "./elConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports